import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationStatusEnum } from "../../models/enum/application-status.enum";

export interface ApplicationStageDStates {
  application_uuid: string | undefined,
  application_status: ApplicationStatusEnum | undefined,
  is_financial_plan_ready: boolean,
}

const initialState: ApplicationStageDStates = {
  application_uuid: undefined,
  application_status: undefined,
  is_financial_plan_ready: false
};

const ApplicationStageDSlice = createSlice({
  name: "Application Stage D Slice",
  initialState,
  reducers: {
    updateStageDApplicationUUID: (state, action: PayloadAction<string>) => {
      state.application_uuid = action.payload;
    },
    updateStageDApplicationStatus: (state, action: PayloadAction<ApplicationStatusEnum>) => {
      state.application_status = action.payload;
    },
    updateStageDFinancialPlanReady: (state, action: PayloadAction<boolean>) => {
      state.is_financial_plan_ready = action.payload;
    },
    resetStageDStates:(state) =>{
      state.application_status = undefined;
      state.is_financial_plan_ready = false;
    }
  },
  extraReducers: {},
});

export const { updateStageDApplicationStatus, updateStageDFinancialPlanReady, resetStageDStates, updateStageDApplicationUUID } = ApplicationStageDSlice.actions;

export default ApplicationStageDSlice.reducer;
